module.exports = __webpack_public_path__ + "static/media/ar.e8d440d9.svg";